import { render } from "./CurrencySwitcher.vue?vue&type=template&id=a98a4a3a"
import script from "./CurrencySwitcher.vue?vue&type=script&lang=js"
export * from "./CurrencySwitcher.vue?vue&type=script&lang=js"
script.render = render

export default script